<h2 mat-dialog-title>Attribute</h2>

<mat-dialog-content class="filter-dialog-content">
  <ng-template #ruleSetTemplate let-formGroup="formGroup" let-parentGroup="parentGroup" let-index="index">
    <div class="ruleset" [formGroup]="formGroup">
      <div class="ruleset-header">
        <mat-button-toggle-group formControlName="condition" aria-label="Condition">
          <mat-button-toggle value="AND">AND</mat-button-toggle>
          <mat-button-toggle value="OR">OR</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="ruleset-actions">
          <button mat-raised-button color="primary" (click)="addRule(formGroup)">Rule</button>
          <button mat-raised-button color="primary" (click)="addRuleSet(formGroup)">Rule set</button>
          <button *ngIf="parentGroup" mat-icon-button class="delete-ruleset-button" (click)="removeRule(parentGroup, index)">
             <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="getRules(formGroup).controls.length === 0 && formGroup.touched" class="validation-error">
        Please add a rule or a rule set.
      </div>
      
      <div formArrayName="rules" class="rules-container">
        <div *ngFor="let control of getRules(formGroup).controls; let i = index" class="rule-or-ruleset-container">
          <ng-container [formGroupName]="i">
            <div *ngIf="!isRuleSet(control)" class="rule">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Attribute</mat-label>
                <mat-select formControlName="field" (selectionChange)="onFieldSelectionChange(control)">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="getRuleFieldSearchControl(control)"
                      placeholderLabel="Search attribute"
                      noEntriesFoundLabel="No matching attributes">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let field of getFilteredFields(control)" [value]="field.value">
                    {{ field.viewValue }}
                  </mat-option>
                </mat-select>
                 <mat-error *ngIf="control.get('field')?.hasError('required')">Attribute is required</mat-error>
              </mat-form-field>
              
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Operator</mat-label>
                <mat-select formControlName="operator">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="getRuleOperatorSearchControl(control)"
                      placeholderLabel="Search operator"
                      noEntriesFoundLabel="No matching operators">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let op of getFilteredOperators(control)" [value]="op.value">
                    {{ op.viewValue }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="control.get('operator')?.hasError('required')">Operator is required</mat-error>
              </mat-form-field>

              <ng-container *ngIf="shouldShowValueField(control)">
                <ng-container *ngIf="isDomainAttribute(control.get('field')?.value); else freeFormValue">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="value" [disabled]="isDomainAttributeLoading(control.get('field')?.value)">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="getRuleValueSearchControl(control)"
                          placeholderLabel="Search value"
                          noEntriesFoundLabel="No matching values">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngIf="isDomainAttributeLoading(control.get('field')?.value)" disabled>
                        Loading...
                      </mat-option>
                      <mat-option *ngFor="let option of getFilteredDomainAttributeOptions(control)" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="control.get('value')?.hasError('required')">Value is required</mat-error>
                  </mat-form-field>
                </ng-container>
              </ng-container>

              <ng-template #freeFormValue>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Value</mat-label>
                  <input matInput formControlName="value">
                  <mat-error *ngIf="control.get('value')?.hasError('required')">Value is required</mat-error>
                </mat-form-field>
              </ng-template>

              <button mat-icon-button (click)="removeRule(formGroup, i)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>

            <ng-container *ngIf="isRuleSet(control)">
              <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: control, parentGroup: formGroup, index: i }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: queryForm, parentGroup: null, index: -1 }"></ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onApply()" [disabled]="isApplyDisabled()">Apply</button>
</mat-dialog-actions>
